module.exports = __webpack_public_path__ + "static/media/Oilex4.b4cc1375.jpg";